// src/components/receipe.js
// Recipe-only data (no product images)

const recipes = [
  {
    productId: "classic-tahini-16oz",
    id: "classic-tahini-16oz-recipe",
    title: "Hummus",
    description: "A creamy, protein-packed dip made with chickpeas and tahini — a true classic.",
    ingredients: [
      "1 can (400g) chickpeas, drained and rinsed",
      "3 tbsp tahini",
      "2 tbsp olive oil",
      "Juice of 1 lemon",
      "1 garlic clove",
      "Salt to taste",
      "2–3 tbsp water (for consistency)"
    ],
    instructions: [
      "Blend chickpeas, tahini, lemon juice, garlic, and olive oil until smooth.",
      "Add water slowly to reach your preferred creaminess.",
      "Season with salt and drizzle with olive oil before serving."
    ],
    quickTip: "Serve with warm pita or fresh veggies. Keeps in the fridge for 3–4 days."
  },
  {
    productId: "100-sesame-tahini",
    id: "100-sesame-tahini-recipe",
    title: "Baba Ganoush",
    description: "A smoky eggplant dip balanced by tahini’s nutty creaminess.",
    ingredients: [
      "2 medium eggplants",
      "2 tbsp tahini",
      "2 tbsp olive oil",
      "Juice of 1 lemon",
      "1 garlic clove",
      "Salt to taste"
    ],
    instructions: [
      "Roast eggplants (whole) in the oven at 200°C until soft and charred (30–40 min).",
      "Scoop out the flesh and blend with tahini, lemon juice, garlic, and olive oil.",
      "Season with salt and drizzle with olive oil before serving."
    ],
    quickTip: "For extra smokiness, char the eggplants directly over a flame before blending."
  },
  {
    productId: "product-3",
    id: "product-3-recipe",
    title: "Falafel with Tahini Sauce",
    description: "Crispy falafels meet a tangy tahini sauce for the perfect bite.",
    ingredients: [
      "3 tbsp tahini",
      "Juice of 1 lemon",
      "1 garlic clove (minced)",
      "3–4 tbsp water (to thin)",
      "Salt to taste"
    ],
    instructions: [
      "Whisk tahini, lemon juice, garlic, and water until smooth and pourable.",
      "Season with salt."
    ],
    quickTip: "Use this sauce not just for falafel, but also as a drizzle over wraps, salads, or grilled veggies."
  },
  {
    productId: "product-4",
    id: "product-4-recipe",
    title: "Tahini Salad Dressing",
    description: "A creamy, dairy-free dressing that makes any salad shine.",
    ingredients: [
      "2 tbsp tahini",
      "1 tbsp olive oil",
      "Juice of ½ lemon",
      "1 tsp honey or maple syrup",
      "2–3 tbsp water",
      "Salt & pepper to taste"
    ],
    instructions: [
      "Whisk all ingredients together until smooth.",
      "Adjust water for a thinner or thicker consistency."
    ],
    quickTip: "This works beautifully over green salads, grain bowls, or roasted vegetables."
  },
  {
    productId: "product-5",
    id: "product-5-recipe",
    title: "Tahini Brownies",
    description: "Fudgy brownies with swirls of nutty tahini for a rich twist.",
    ingredients: [
      "100g dark chocolate",
      "100g butter (or coconut oil)",
      "150g sugar",
      "2 eggs",
      "75g flour",
      "3 tbsp tahini"
    ],
    instructions: [
      "Melt chocolate and butter together.",
      "Stir in sugar, then eggs one at a time.",
      "Fold in flour.",
      "Pour batter into a lined baking dish, swirl tahini on top.",
      "Bake at 180°C for 20–25 minutes."
    ],
    quickTip: "Don’t overbake — a slightly gooey center makes them extra delicious."
  },
  {
    productId: "product-6",
    id: "product-6-recipe",
    title: "Tahini Smoothie",
    description: "A creamy, protein-rich smoothie with a nutty sesame kick.",
    ingredients: [
      "1 banana",
      "1 tbsp tahini",
      "200ml milk (or plant-based alternative)",
      "1 tsp honey or maple syrup",
      "A pinch of cinnamon (optional)"
    ],
    instructions: [
      "Blend all ingredients until smooth.",
      "Adjust sweetness as desired."
    ],
    quickTip: "Add a spoonful of oats or chia seeds for extra fiber and energy."
  }
];

export default recipes;
